import { Avatar, DirectoryRow, Pushtext } from '@stratumn/atomic';

import PropType from 'prop-types';
import injectSheet from 'react-jss';
import pluralize from 'utils/pluralize';

import styles from './botRow.style';

export function BotRow(props) {
  const {
    classes,
    bot: { avatar, name, rowId, teams },
    botsTotalCount,
    index,
    onClick
  } = props;

  const renderMain = (
    <Pushtext data-testid="bot-row-button" onClick={() => onClick(rowId)}>
      <div className={classes.link}>
        <Avatar size={32} src={avatar} />
        <span className={classes.botName}>{name}</span>
      </div>
    </Pushtext>
  );

  return (
    <DirectoryRow
      cell1={pluralize('Team', teams.totalCount)}
      isLast={index === botsTotalCount}
      main={renderMain}
    />
  );
}

BotRow.propTypes = {
  classes: PropType.object.isRequired,
  bot: PropType.object.isRequired,
  botsTotalCount: PropType.number.isRequired,
  index: PropType.number.isRequired,
  onClick: PropType.func.isRequired
};

export default injectSheet(styles)(BotRow);
